import React, { useContext } from 'react';

import { AppConfigContext } from '@providers/AppConfigProvider';

export default function SellLabel(): React.JSX.Element {
  const { pathRoot } = useContext(AppConfigContext);
  return <img src={`${pathRoot}/assets/images/common/sell.svg`} alt="sellLabel" />;
}
